import { render, staticRenderFns } from "./TInputWrapper.vue?vue&type=template&id=561f1ca6&scoped=true&"
import script from "./TInputWrapper.vue?vue&type=script&lang=js&"
export * from "./TInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TInputWrapper.vue?vue&type=style&index=0&id=561f1ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f1ca6",
  null
  
)

export default component.exports